module.exports = __webpack_public_path__ + "static/background__stories-1-e4cd67481e6da98b4f07f6e391b5b08d.jpg";